export default () => {
    setTimeout(() => {
        document.querySelector("#fab").classList.remove("hidden");
    }, 5000);

    return (
        <div
            id="fab"
            className="fixed bottom-0 right-0 mb-8 mr-4 hidden xs:bottom-0 xs:right-auto xs:left-1/2 xs:transform xs:-translate-x-1/2 sm:bottom-0 sm:right-auto sm:left-1/2 sm:transform sm:-translate-x-1/2 md:bottom-0 md:right-0 md:left-auto md:transform-none lg:bottom-0 lg:right-0 lg:left-auto lg:transform-none xl:bottom-0 xl:right-0 xl:left-auto xl:transform-none"
        >
            <a
                href="/twaalf-weken-programma"
                className="bg-we-are-purple text-gray-100 hover:bg-we-are-yellow hover:text-gray-900 py-4 px-6 uppercase font-medium text-base rounded-md shadow-sm whitespace-nowrap"
            >
                Start Jouw Transformatie
            </a>
        </div>
    );
};
